import { Trophy, LogOut } from 'lucide-react';
import type { AppUser } from '../types';

interface NavbarProps {
  currentUser: AppUser;
  onLogout: () => void;
}

const Navbar = ({ currentUser, onLogout }: NavbarProps) => (
  <nav className="bg-white border-b border-slate-200 sticky top-0 z-20 shadow-sm">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex justify-between h-16">
        <div className="flex items-center">
          <Trophy className="w-6 h-6 text-indigo-600 mr-2" />
          <div>
            <span className="font-bold text-xl tracking-tight block leading-none">
              METRO PICKLE LEAGUE <span className="text-indigo-600">- Season 3</span>
            </span>
            <span className="text-xs text-slate-500 font-medium">
              {currentUser.name} ({currentUser.role.replace('_', ' ')})
            </span>
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <button
            onClick={onLogout}
            className="p-2 text-slate-400 hover:text-red-500 transition-colors"
            title="Logout"
          >
            <LogOut className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  </nav>
);

export default Navbar;

